//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider, Tag, DatePicker, TimeSelect, Select, Option, Col, Button, Upload, Checkbox} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
import CySelect from '../../../components/select/CySelect'
import CyAutocomplete from '../../../components/autocompletes/CyAutocomplete'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Checkbox)
export default {
  name: 'stockInPlanConfirm',
  components: {
    CyMobileLayout,
    CySelect,
    CyAutocomplete
  },
  data () {
    return {
      jgFlag: true,
      ctnFlag: false,
      weightFlag: false,
      pictureFlag: false,
      planId: this.$route.query.planId,
      confirm_status: '',
      baseInfo: {},
      stockIn: {stockio_plan_id: '', confirm_plan_date: '', planDate: '', planTime: '', stockio_amount: ''}, // 入库信息
      dateList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      let that = this
      let url = '/wms/stockin/plan/getStockInPlanDateInfo'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          // 剩余未确认任务
          that.stockIn.confirm_plan_date = res.data.baseInfo.expected_arrival_date
          that.stockIn.total_amount = res.data.amount
          that.stockIn.stockio_amount = res.data.remain_amount
          // 已确认时间计划列表
          that.dateList = res.data.dateList
          that.stockIn.stockio_plan_id = res.data.baseInfo.stockin_plan_id
          that.confirm_status = res.data.baseInfo.confirm_status
        }
      })
    },
    submitConfirm: function () {
      let that = this
      that.$refs.mainFrm.validate((valid) => {
        if (valid) {
          that.stockIn.confirm_plan_date = that.stockIn.planDate + ' ' + that.stockIn.planTime + ':00'
          let url = '/wms/stockin/plan/confirmStockInPlan'
          let stockinParam = {}
          if (that.$Utils.IsEmpty(that.stockIn.stockio_amount)) {
            that.$Msgbox.alert('请填写数量')
            return false
          }
          if (that.stockIn.stockio_amount < 1) {
            that.$Msgbox.alert('数量必须大于0')
            return false
          }
          stockinParam.stockIn = that.stockIn
          that.$axiosWeb.post(url, stockinParam).then(function (res) {
            if (res.meta.success) {
              that.$Msgbox.alert('确认成功', '确认成功')
              location.href = '/wx/wms/stockInPlanConfirm?planId=' + that.planId
            } else {
              that.$Msgbox.alert(res.meta.message, '确认失败')
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockin/StockInPlanConfirm.vue